import {talentSearchTypes} from "./actionsType";
import Tools from "../../../../Tools";
import {initState} from "../../../reducers/TalentSearch/TalentSearchReducer";
import {watchlistTypes} from "../Watchlist/actionsType";

const defaultOptions = {
    NUMBER_SLIDER: (option) => ({from: option.min, to: option.max}),
    TOGGLE_SELECTOR: (option) => (option.options[0]),
};


export const setPerformanceFilter = (group, filter, value) => (dispatch, getState) => {
    const state = getState();
    const performance = state.talentSearch.filters.performance;

    if (!performance[group])
        performance[group] = {};

    performance[group][filter] = value;

    dispatch({
        type: talentSearchTypes.SET_PERFORMANCE_FILTERS,
        performance: JSON.parse(JSON.stringify(performance)),
    });
};


export const setPerformanceGroupFilters = (groupName, filters) => (dispatch, getState) => {
    const state = getState();
    const performance = state.talentSearch.filters.performance;

    const formattedFilters = filters.reduce((result, filter) => {
        const {value: filterProps} = filter;
        const {name: filterName, type} = filterProps;

        let value;
        if (performance[groupName] && performance[groupName][filterName]) {
            value = performance[groupName][filterName];
        } else {
            value = defaultOptions[type](filterProps);
        }

        result[filterName] = value;
        return result;
    }, {});

    dispatch({
        type: talentSearchTypes.SET_PERFORMANCE_GROUP_FILTERS,
        groupName: groupName,
        filters: JSON.parse(JSON.stringify(formattedFilters)),
    });
};

export const initTalentSearchFilters = (initFilters) => {
    return {
        type: talentSearchTypes.INIT_FILTERS,
        initFilters: initFilters,
    };
};

export const clearTalentSearchFilters = () => {
    return {
        type: talentSearchTypes.CLEAR_FILTERS,
    };
};

// Regions
export const setRegionsFilter = (regions) => {
    return {
        type: talentSearchTypes.SET_REGIONS_FILTER,
        regions: regions,
    };
};

// Countries
export const setCountriesFilter = (countries) => {
    return {
        type: talentSearchTypes.SET_COUNTRIES_FILTER,
        countries: countries,
    };
};

// Seasons
export const setSeasonsFilter = (seasons) => {
    return {
        type: talentSearchTypes.SET_SEASONS_FILTER,
        seasons: seasons,
    };
};

// Competitions
export const setCompetitionsFilter = (competitions) => {
    return {
        type: talentSearchTypes.SET_COMPETITIONS_FILTER,
        competitions: competitions,
    };
};

// Select player.
export const toggleSelectPlayer = (player) => {
    return {
        type: talentSearchTypes.TOGGLE_SELECT_PLAYER,
        player: player
    };
};

// Pagination.
export const setPagination = (pagination) => {
    return {
        type: talentSearchTypes.SET_PAGINATION,
        pagination: pagination,
    }
};

// Search.
export const setSearchValue = (value) => dispatch => {
    dispatch({
        type: talentSearchTypes.SET_TEMP_SEARCH_VALUE,
        search: value,
    });
    Tools.delay(() => dispatch({
        type: talentSearchTypes.SET_SEARCH_VALUE,
        search: value,
    }), 500, talentSearchTypes.SET_SEARCH_VALUE)
};

// Expand
export const setExpandRow = (row, isExpand) => {
    return {
        type: talentSearchTypes.SET_EXPAND_ROW,
        row: row,
        isExpand: isExpand,
    };
};

export const isFilterCleared = () => (dispatch, getState) => {
    const state = getState();
    const filters = state.talentSearch.filters;

    return filters === initState.filters;
};

// Sort table
export const setSort = (field, order) => {

    return {
        type: talentSearchTypes.SET_SORT,
        field: field,
        order: order
    }
};
